import ArrowUpIcon from "@root/assets/icons/arrowupicon";
import { Box, Flex, HStack, Text } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { CenterContainer, StatContainer } from "./style";
import { useTranslation } from "react-i18next";
import { useDashboard } from "@root/hooks/useDashboard";
import { Icon } from "@chakra-ui/react";
import { FolderIcon } from "@root/assets/icons/foldericon";
import { GreenArrow } from "@root/assets/icons/GreenArrow";
import HazardIcon from "@root/assets/icons/hazardIcon";
import ShieldIcon from "@root/assets/icons/shieldIcon";
import NotificationIcon from "@root/assets/icons/notificationIcon";

const cardBg = "white";
const cardBorder =
  " 1px solid linear-gradient(108.2deg, #005EB8 4.16%, #B15906 100.98%)";
const cardRadius = "16px";

export const StatsCards = () => {
  const { fetchStats, statsLoading, stats: statsData } = useDashboard();
  const { t } = useTranslation("common");

  useEffect(() => {
    fetchStats();
  }, []);

  const stats = useMemo(
    () => [
      {
        title: t("dashboard.identifiedHazards"),
        value: 100,
        unit: "",
        change: "-8 vs last week",
        color: "#3AB65A",
        icon: HazardIcon,
      },
      {
        title: t("dashboard.risk"),
        value: 100,
        unit: "s",
        change: "120 vs last week",
        color: "#40599B",
        icon: HazardIcon,
      },
      {
        title: t("dashboard.aiReviews"),
        value: 100,
        unit: "%",
        change: "98 vs last week",
        color: "#B6863A",
        icon: ShieldIcon,
      },
      {
        title: t("dashboard.riskAssessments"),
        value: 100,
        unit: "",
        change: "10 vs last week",
        color: "#B63AA5",
        icon: NotificationIcon,
      },
    ],
    [t, statsData]
  );

  return (
    <Flex gap={4} mb={6} flexWrap={{ base: "wrap", md: "nowrap" }} m={6}>
      {stats?.map((stat: any, idx: number) => (
        <Box
          key={stat?.title}
          flex="1"
          p="1px"
          borderRadius="16px"
          bg="linear-gradient(108.2deg, #005EB8 4.16%, #B15906 100.98%)"
          height="192px"
        >
          <StatContainer bg="white" height="100%" padding="24px">
            {/* <Flex justifyContent="space-between">
              <Text fontSize="lg" fontWeight="500">
                {stat?.title}
              </Text>
              <Icon as={stat?.icon} />
            </Flex> */}
            <Flex
              justifyContent="space-between"
              mb="16px"
              width="100%"
              alignItems="center"
            >
              <Text fontSize="16px" fontWeight="500" color="#5C6670">
                {stat?.title}
              </Text>
              <Icon as={stat?.icon as any} color="#5C6670" />
            </Flex>
            <Text fontSize="32px" fontWeight="700" color="black">
              {stat?.value}
              <Text
                as="span"
                fontSize="16px"
                fontWeight="500"
                color="#5C6670"
                ml="1"
              >
                {stat?.unit}
              </Text>
            </Text>

            <HStack spacing={1}>
              <GreenArrow />
              <Text fontSize="14px" fontWeight="500" color="#3AB65A">
                {stat?.change}
              </Text>
            </HStack>
          </StatContainer>
        </Box>
      ))}
    </Flex>
  );
};
